// バックエンド（api/src/constants/plan-limits.ts）と対応する featureKey 定義。
export type FeatureKey =
  | 'max_patients'
  | 'max_accounts'
  | 'max_photos_per_month'
  | 'archive'
  | 'advanced_search'
  | 'folder_tag'
  | 'csv_download'
  | 'item_memo'
  | 'care_protocol'
  | 'multilingual';

// 機能フラグ系（0/1）のうち、ライトプラン限定のもの。
// フロントの canUse() はこの一覧をライト限定判定に使う。
// ※ archive（患者のアーカイブ／削除）は無料プランにも開放済みのため含めない。
export const FLAG_FEATURE_KEYS: FeatureKey[] = [
  'advanced_search',
  'folder_tag',
  'csv_download',
  'item_memo',
  'care_protocol',
  'multilingual',
];

export const isFlagFeature = (key: FeatureKey): boolean =>
  FLAG_FEATURE_KEYS.includes(key);
